export const METRICS = [
  {
    key: 'revenue',
    label: 'Выручка',
    unit: 'money'
  },
  {
    key: 'grossProfit',
    label: 'Чистая прибыль',
    unit: 'money'
  },
  {
    key: 'receipts',
    label: 'Кол. чеков',
    unit: 'number'
  },
  {
    key: 'units',
    label: 'Проданные единицы',
    unit: 'number'
  },
  {
    key: 'averageReceipt',
    label: 'Средний чек',
    unit: 'money'
  },
  {
    key: 'unitsPerReceipt',
    label: 'Товаров в чеке',
    unit: 'number'
  },
  {
    key: 'marginPercent',
    label: 'Валовая маржа',
    unit: 'percent',
    hint: 'Валовая маржа - это % выручки, который остается у компании после вычета прямых затрат на производство или закупку товара (себестоимости).'
  },
  {
    key: 'cost',
    label: 'Закупочная стоимость',
    unit: 'money'
  },
  {
    key: 'salesCommission',
    label: 'ЗП',
    unit: 'money'
  },
  {
    key: 'returnedReceipts',
    label: 'Возвращённые чеки',
    unit: 'number'
  },
  {
    key: 'returnedRevenue',
    label: 'Сумма возвратов',
    unit: 'money'
  },
  {
    key: 'returnRatePercent',
    label: 'Доля возвратов',
    unit: 'percent'
  }
]

export const CHARTS = [
  {
    key: 'revenue',
    title: 'Выручка и прибыль',
    type: 'line',
    unit: 'money',
  },
  {
    key: 'receipts',
    title: 'Продажи и возвраты',
    type: 'bar',
    unit: 'number'
  },
  {
    key: 'averageReceipt',
    title: 'Средний чек',
    type: 'line',
    unit: 'money'
  },
  {
    key: 'payments',
    title: 'Способы оплаты',
    type: 'doughnut',
    unit: 'money'
  },
  {
    key: 'hours',
    title: 'Продажи по часам',
    type: 'bar',
    unit: 'number'
  },
  {
    key: 'weekdays',
    title: 'Продажи по дням недели',
    type: 'bar',
    unit: 'number'
  },
  {
    key: 'topProducts',
    title: 'Топ товаров по количеству',
    type: 'bar',
    unit: 'number'
  },
  {
    key: 'sellers',
    title: 'Выручка продавцов',
    type: 'bar',
    unit: 'money'
  }
]

export default {
  CHARTS,
  METRICS,
}